import { render } from "./TermsHeader.vue?vue&type=template&id=3e16c273&scoped=true&ts=true&lang=pug"
import script from "./TermsHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TermsHeader.vue?vue&type=style&index=0&id=3e16c273&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e16c273"]])

export default __exports__